import {
  FDAccordion,
  FDAccordionDetails,
  FDAccordionGroup,
  FDAccordionTitle,
  FDLozenge,
  FDStack,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import React from 'react';
import { dataAttrs } from 'Helpers/Testing';
import { BodyTextLarge } from 'Packages/FacetDesign/Components';
import {
  TaxStrategyItem,
} from './TaxStrategyItem';

export const TaxStrategyGeneralAccordionGroup = ({
  resource,
}) => {
  return (
    <FDAccordionGroup {...dataAttrs('tax-strategy-accordion-group')}>
      {resource.attr('groups').resources().list().map(group => {
        const groupHasItemWithNote = group.attr('items').resources().list().some(item => item.isTruthy('hasNote'));
        return (
          <FDAccordion
            key={group.id()}
            expansionID={group.id()}
            {...dataAttrs('tax-strategy-general-group-accordion')}
          >
            <FDAccordionTitle>
              <FDStack direction={'row'} width={'100%'} justifyContent={'space-between'} alignItems={'center'}>
                <FDStack direction={'row'} spacing={1}>
                  <FDStack alignItems={'center'}>
                    <FDLozenge
                      label={group.attr('quantityText')}
                      color={'info'}
                      alignSelf={'center'}
                      size={'lg'}
                      {...dataAttrs('tax-strategy-group-lozenge')}
                    />
                  </FDStack>
                  <BodyTextLarge value={group.attr('name')} />
                </FDStack>
                {groupHasItemWithNote && (
                  <FDLozenge
                    label={'Notes'}
                    color={'info'}
                    size={'lg'}
                    {...dataAttrs('tax-strategy-group-note-lozenge')}
                  />
                )}
              </FDStack>
            </FDAccordionTitle>
            <FDAccordionDetails>
              <FDStack direction={'column'} spacing={1}>
                {
              group.attr('items')?.resources().list().map(item => (
                <TaxStrategyItem itemResource={item} key={item.id()} />
              ))
            }
              </FDStack>
            </FDAccordionDetails>
          </FDAccordion>
        );
      })}
    </FDAccordionGroup>
  );
};

TaxStrategyGeneralAccordionGroup.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
